export default "__VITE_ASSET__BYI$WO24__"